import React from "react";
import styled, { css } from "styled-components";
import theme from "styled-theming";
import CustomPopover from "shared/components/Popover";
import colors from "shared/styles/colors";
import { ThemeType } from "shared/styles/theme";
import { Utilities } from "shared/utilities";

interface IDescriptionListProps {
    itemsPerRow?: number;
}

export const DescriptionList = styled.dl`
    margin: 0;
    gap: 1rem;
    display: grid;
    dt {
        display: flex;
        align-items: center;
        gap: 0.625rem;

        font-size: 1.125rem;
        font-family: "Gilroy-Medium", "medium-fallback";
        margin-bottom: 0.25rem;
    }

    dd {
        margin: 0;
        padding: 0.5rem 1rem;
        overflow-wrap: break-word;
    }

    dd div {
        min-width: 0;
        word-wrap: break-word;
    }

    pre {
        white-space: break-spaces;
        overflow-wrap: break-word;
    }
`;

export const DescriptionListGroup = styled.div<IDescriptionListProps>`
    display: grid;
    align-items: start;
    > * {
        min-width: 0;
    }
    ${props => props.itemsPerRow && css`
        grid-template-columns: repeat(${props.itemsPerRow}, 1fr);
    `}
   
`;

interface IDescriptionListItemProps {
    dt: string;
    dd?: string | number | null;
    preformat?: boolean;
    tooltip?: string;
    showCopyButton?: boolean;
    onCopyClick?: () => void | Promise<void>;
}

export const DescriptionListItem: React.FC<IDescriptionListItemProps> = ({
    dt,
    dd,
    preformat,
    tooltip,
    showCopyButton = false,
    onCopyClick
}) => (
    <>
        {dd !== undefined && dd !== null && (
            <div>
                <dt>
                    <span>
                        {dt}
                    </span>

                    {tooltip && (
                        <CustomPopover
                            position={["top"]}
                            tooltip={tooltip}
                        >
                            <i className="ci-help_circle_outline pointer" />
                        </CustomPopover>
                    )}

                    {showCopyButton && (
                        <StyledIconButton
                            type="button"
                            onClick={onCopyClick}                            
                            id="copy"
                        >
                            <i className="ci-copy" />
                        </StyledIconButton>
                    )}
                </dt>
                <dd>
                    {preformat === true ? (
                        <pre>
                            {dd}
                        </pre>
                    ) : (
                        <>
                            {dd}
                        </>
                    )}
                </dd>
            </div>
        )}
    </>
);

const iconColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.white
});

const StyledIconButton = styled.button`
    all: unset;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0.25rem;
    color: ${iconColor};
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }

    i {
        font-size: 1.25rem;
    }
`;
